<template>
    <div id="phone-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                :placeholder="$t('message.phoneNumber')"
                v-model="item.phone.fieldPhone"
                @input="setFieldPhone(item.phone.fieldPhone)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: align === 'left' }" @click="setLabelAlign('left')">{{ $t("form.left") }}
                </button>
                <button class="button" :class="{ active: align === 'right' }" @click="setLabelAlign('right')">{{ $t("form.right") }}
                </button>
                <button class="button" :class="{ active: align === 'top' }" @click="setLabelAlign('top')">{{ $t("form.top") }}
                </button>
            </div>
            <!--            <div class="checkbox-group">-->
            <!--                <input type="checkbox" id="default-align" class="checkbox" v-model="defaultAlign">-->
            <!--                <label for="default-align" class="checkbox-label">Varsayılan olarak ayarla</label>-->
            <!--            </div>-->
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.required") }}</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ requiredText }}</span>
            </div>
            <small class="form-description">{{ $t("form.fieldEmptyError") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: visibility }"
                      @click="toggleVisibility">{{ visibility ? "Görünür" : "Gizli" }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="alan-slug-degeri"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.subLabels") }}</label>
            <div class="sub-labels">
                <div class="sub-label-item">
                    <label for="masked" class="sub-label">{{ $t("form.masked") }}</label>
                    <input
                        type="text"
                        id="masked"
                        class="sub-label-input"
                        :placeholder="$t('form.validPhoneNumber')"
                        v-model="item.phone.masked"
                        @input="setMasked(item.phone.masked)"
                    >
                </div>
            </div>
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "PhoneSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldPhone: this.item.phone.fieldPhone,
            align: this.item.phone.align,
            masked: this.item.phone.masked,
            isRequired: this.item.phone.isRequired,
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            defaultAlign: false,
            updateTimer: null,
        };
    },
    computed: {
        requiredText() {
            return this.isRequired ? this.$t("chatWindow.open") : this.$t("chatWindow.closed");
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setLabelAlign(align) {
            this.align = align;
            this.$emit("update-label-align-phone", align);
            this.updateFields();
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.updateFields();
            this.$emit("update-required", this.isRequired);
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateFields();
            this.$emit("update-visibility", this.visibility);
        },
        duplicateField() {
            console.log("Field duplicated");
        },
        setFieldPhone(value) {
            this.fieldPhone = value;
            this.$emit("update-field-phone", value);
            this.updateFields();
        },
        setMasked(value) {
            this.masked = value;
            this.$emit("update-masked-phone", value);
            this.updateFields();
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.$emit("update-slug", this.slug);
            this.updateFields();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateFields() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateField = {
                    visibility: self.visibility,
                    slug: self.slug,
                    phone: {
                        fieldPhone: self.fieldPhone,
                        align: self.align,
                        masked: self.masked,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateField,
                });
            }, 800);
        },

    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.phone) { return; }
                this.fieldPhone = val.phone.fieldPhone;
                this.align = val.phone.align;
                this.masked = val.phone.masked;
                this.isRequired = val.phone.isRequired;
                this.visibility = typeof val.visibility !== 'undefined' ? val.visibility : this.visibility;
                this.slug = val.slug || '';
            },
            deep: true,
            immediate: false,
        },
        'item.phone.fieldPhone': function (v) { this.fieldPhone = v; },
        'item.phone.align': function (v) { this.align = v; },
        'item.phone.masked': function (v) { this.masked = v; },
        'item.phone.isRequired': function (v) { this.isRequired = v; },
        'item.visibility': function (v) { this.visibility = v; },
        'item.slug': function (v) { this.slug = v || ''; },
    },
};
</script>

<style lang="scss" scoped>
#phone-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #059669;
                    color: #ffffff;
                    border-color: #059669;
                    box-shadow: 0 1px 3px rgba(5, 150, 105, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .sub-labels {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .sub-label-item {
                display: flex;
                flex-direction: column;

                .sub-label {
                    font-weight: 600;
                    color: #374151;
                    margin-bottom: 4px;
                    font-size: 0.8rem;
                }

                .sub-label-input {
                    padding: 6px 10px;
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    background-color: #ffffff;
                    color: #374151;
                    font-size: 0.8rem;
                    transition: border-color 0.2s ease, box-shadow 0.2s ease;

                    &:focus {
                        outline: none;
                        border-color: #f26a52;
                        box-shadow: 0 0 0 2px rgba(242, 106, 82, 0.1);
                    }

                    &::placeholder {
                        color: #9ca3af;
                    }
                }
            }
        }
    }
}
</style>
